<template>
  <div class="content">
     <router-view />
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "App",
  data() {
    return {
      days: [0, 0, 0, 0, 0],
      isOpen: false,
      user: {
        nickName: "",
      },
      days: [],
      isLogin: getToken(),
      hoveredIndex: null, // 记录当前鼠标悬停的项的索引
      path: null || window.location.pathname,

    };
  },
  methods: {
    doLogout() {
      this.$confirm("是否确认退出登录？")
        .then((_) => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        })
        .catch((_) => {});
    },
    timeOut() {
      // 设置目标日期和时间
      const targetDate = new Date("2026-10-18").getTime();
      const currentDate = new Date().getTime();
      // 计算差值并转换为天 向上去整
      const timeDifference = targetDate - currentDate;
      const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      this.days = daysRemaining.toString().padStart(5, "0");
      console.log(daysRemaining);
    },
    loginBybtn() {
      window.open("http://41.236.4.110:8083/login");
    },
    getPath(path, index) {
      this.$router.push(path);
    },
    hoverIn(index) {
      // 鼠标悬停时，更新对应项的图片为选中状态
      // this.navArr[index].current = this.navArr[index].selected
      // this.hoveredIndex = index // 更新记录
    },
    hoverOut(index) {
      // this.hoveredIndex = null
      // this.navArr[index].current = this.navArr[index].notSelected
    },
  },
  // 监听路由变化监听

  mounted() {

  },
  created() {
    const user = JSON.parse(localStorage.getItem("user"));

  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue